import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Dashboard from './components/pages/Dashboard';
import HokBankPay from './components/pages/HokBankPay';
import CreditcardHok from './components/pages/CreditcardHok';
import CreditcardPay from './components/pages/CreditcardPay';
import ThankYouPage from './components/pages/ThankYouPage';
import ThankYouPageHokBankPay from './components/pages/ThankYouPageHokBankPay';
import CashOrCheckPay from './components/pages/CashOrCheckPay';
import NoPaymentThankYouPage from './components/pages/NoPaymentThankYouPage';
import NoPayments from './components/pages/NoPayments';
import AdminPage from './components/pages/Admin/AdminPage';
import RouteErrorBoundary from './components/RouteErrorBoundary';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Dashboard />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: 'thankYouPageRedirect',
    element: <ThankYouPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/:authorityName',
    element: <Layout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        path: '',
        element: <Dashboard />,
      },
      
      {
        path: 'hokBankPay',
        element: <HokBankPay />,
      },
      {
        path: 'creditcardHok',
        element: <CreditcardHok />,
      },
      {
        path: 'creditcardPay',
        element: <CreditcardPay />,
      },
      {
        path: 'cashOrCheckPay',
        element: <CashOrCheckPay />,
      },
      {
        path: 'thankYouPageHokBankPay',
        element: <ThankYouPageHokBankPay />,
      },
      {
        path: 'noPaymentThankYouPage',
        element: <NoPaymentThankYouPage />,
      },
      {
        path: 'noPayments',
        element: <NoPayments />,
      },

    ],
  },
]);

export default router;
